module.exports = __webpack_public_path__ + "static/media/deactiveMemKan.a8d5dffc.jpg";